export default {
    pageTitle: 'Orders',
    listing: {
        content: 'License type',
        date: 'Creation date',
        new: 'Order',
        number: '# Order',
        pageTitle: 'Orders',
        quantity: 'Quantity',
        remainingLicenses: 'Remaining',
        status: 'Status',
        noOrders: 'No orders.',
        hideCompleted: 'Hide completed',
        stats: {
            available: 'Available Licenses',
            activated: 'Activated Licenses',
            purchased: 'Purchased Licenses',
        },
        yearToDate: 'YTD',
    },
    modal: {
        cancel: 'Cancel',
        error: {
            input: 'The given data don\'t follow the validation rules',
            invalidData: 'The given data are invalid',
        },
        instructions: 'Once you submit your order, our team will review it before issuing the licenses.',
        licenseType: 'License type',
        quantity: 'Quantity',
        send: 'Order',
        title: 'New order',
    },
    activations: {
        activateLicense: 'Activate a license',
        activations: 'Activations',
        activationsHistory: 'Activations history',
        noActivations: 'No activations yet.',
        activationForm: {
            availableLicenses: '{count} licenses remaining',
            activate: 'Activate',
            licenseType: 'License type',
            afsSerial: 'AFS serial number',
            afsVersion: 'AFS version',
            deviceSerial: 'Device serial number',
            phoneSerial: 'Phone serial number',
            phoneModel: 'Phone model',
            androidVersion: 'Android version',
            computerSerial: 'Computer serial number',
            firmwareVersion: 'Firmware version',
            latestVersion: 'Current: ',
            errors: {
                activationFailed: 'Unable to activate the license with the data provided.',
            },
        },
        licenseKeyModal: {
            title: 'License key',
            button: 'Close',
            copiedToClipboard: 'The license key has been copied to the clipboard.',
        },
        search: 'Search...',
    },
};
